<template>
    <section class="main">
        <div v-show="isLoading">
            <v-page-loading />
        </div>
        <div v-show="!isLoading">
            <v-page-header :title="getPageTile" />

            <div v-show="hasLoadingError">
                <div class="grid-container">
                    <p class="text-center">
                        {{ loadingError }}
                    </p>
                </div>
            </div>

            <div v-show="!hasLoadingError">
                <div class="grid-container">
                    <div class="grid-x">
                        <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                            <div class="wrapper">
                                <v-action-buttons :items="getActionButtons" :isDisabled="adminFormDisabled" @actionClicked="onClickAction" />
                                <v-form-message type="error" id="form-error" :message="adminObjectError" @onClickAction="onClickActivateDialogAction" />
                                <v-form-message type="success" id="form-success" :message="adminObjectSuccess" @onClickAction="onClickActivateDialogAction" />
                                <v-form-message type="default" id="form-activate" :message="adminObjectActivate" :autoCloseTimeout="0" :showActionButtons="true" @onClickAction="onClickActivateDialogAction" />

                                <div class="box">
                                    <v-navigation />

                                    <div class="form-group">
                                        <label for="form-field-salutation">{{ $t('form.account.title') }}</label>
                                        <v-select-salutation id="form-field-salutation" :isStatic="isViewMethod" :placeholder="$t('form.account.title.plc')" v-model="adminObject.profile.salutation" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group form-group--required">
                                        <label>{{ $t('form.account.firstname') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ adminObject.profile.firstname }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group form-group--required" :class="{ 'form-group--error' : $v.adminObject.profile.firstname.$error }">
                                        <label for="form-field-firstname">{{ $t('form.account.firstname') }}</label>
                                        <input type="text" id="form-field-firstname" name="firstname" class="form-control" :placeholder="$t('form.account.firstname.plc')" v-model="$v.adminObject.profile.firstname.$model" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group form-group--required">
                                        <label>{{ $t('form.account.lastname') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ adminObject.profile.lastname }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group form-group--required" :class="{ 'form-group--error' : $v.adminObject.profile.lastname.$error }">
                                        <label for="form-field-lastname">{{ $t('form.account.lastname') }}</label>
                                        <input type="text" id="form-field-lastname" name="lastname" class="form-control" :placeholder="$t('form.account.lastname.plc')" v-model="$v.adminObject.profile.lastname.$model" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group">
                                        <label>{{ $t('form.phone') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ adminObject.profile.communication.phone }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group">
                                        <label for="form-field-phone">{{ $t('form.phone') }}</label>
                                        <input type="text" id="form-field-phone" name="phone" class="form-control" :placeholder="$t('form.phone.plc')" v-model="adminObject.profile.communication.phone" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group">
                                        <label>{{ $t('form.mobile') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ adminObject.profile.communication.mobile }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group">
                                        <label for="form-field-mobile">{{ $t('form.mobile') }}</label>
                                        <input type="text" id="form-field-mobile" name="mobile" class="form-control" :placeholder="$t('form.mobile.plc')" v-model="adminObject.profile.communication.mobile" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group form-group--required">
                                        <label>{{ $t('form.email') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ adminObject.profile.communication.email }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group form-group--required" :class="{ 'form-group--error' : $v.adminObject.profile.communication.email.$error }">
                                        <label for="form-field-email">{{ $t('form.email') }}</label>
                                        <input type="text" id="form-field-email" name="email" class="form-control" :placeholder="$t('form.account.email.plc')" v-model="$v.adminObject.profile.communication.email.$model" />
                                    </div>
                                    <div class="form-group form-group--required" :class="{ 'form-group--error' : $v.adminObject.location_id.$error }">
                                        <label for="form-field-location">{{ $t('form.project.location') }}</label>
                                        <v-select-location id="form-field-location" :customerId="$route.params.customer" :isStatic="isViewMethod" :placeholder="$t('form.project.location.plc')" v-model="$v.adminObject.location_id.$model" />
                                    </div>

                                    
                                    <div class="form-group">
                                        <label for="form-field-user-type-id">{{ $t('form.account.permissions') }}</label>
                                        <select id="form-field-user-type-id" class="form-control form-control--select" name="user_type_id" v-model="adminObject.user_type_id">
                                            <option :value="$helpers.usertypes.client">{{ $t('form.account.permissions.read') }}</option>
                                            <option :value="$helpers.usertypes.clientadmin">{{ $t('form.account.permissions.read_write') }}</option>
                                        </select>
                                    </div>

                                     <div class="form-group">
                                        <label for="form-field-usertype" class="show-for-sr"> {{ $t('form.account.permissions') }}</label>
                                        <v-select-user-type id="form-field-usertype" :isStatic="isViewMethod" v-model="adminObject.user_type_id"/>
                                    </div>   

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from './../../partials/PageHeader';
    import PageLoading from './../../partials/PageLoading';
    import ActionButtons from './../../partials/Foundation/ActionButtons';
    import Navigation from './../Navigation';
    import FormMessage from './../../partials/Forms/FormMessage';
    import { required, email } from 'vuelidate/lib/validators';

    import SelectSalutation from './../../partials/Forms/SelectSalutation';
    import SelectLocation from './../../partials/Forms/SelectLocation';
    import SelectUserType from './../../partials/Forms/SelectUserType';

    export default {
        data() {
            return {
                loading                 : false,
                loadingError            : null,
                customerObject          : {
                    id                      : 0
                },
                adminFormDisabled        : false,
                adminObjectError         : null,
                adminObjectSuccess       : null,
                adminObjectActivate      : null,
                adminObject              : {
                    id                      : 0,
                    user_type_id            : this.$helpers.usertypes.clientadmin,
                    customer_id             : this.$route.params.customer,
                    location_id             : 0,
                    active                  : 1,
                    profile                 : {
                        firstname               : '',
                        lastname                : '',
                        salutation              : '',
                        gender                  : '',
                        position                : '',
                        address                 : {
                            city                    : '',
                            zipcode                 : '',
                            street                  : '',
                            region                  : '',
                            housenumber             : '',
                            country_code            : 'de'
                        },
                        communication           : {
                            email                   : '',
                            mobile                  : '',
                            phone                   : ''
                        }
                    }
                }
            };
        },
        components : {
            vPageHeader             : PageHeader,
            vPageLoading            : PageLoading,
            vActionButtons          : ActionButtons,
            vNavigation             : Navigation,
            vFormMessage            : FormMessage,
            vSelectSalutation       : SelectSalutation,
            vSelectLocation         : SelectLocation,
            vSelectUserType         : SelectUserType
        },
        computed : {
            isLoading : function () {
                return this.loading;
            },
            hasLoadingError : function () {
                return this.loadingError !== null;
            },
            isViewMethod : function () {
                return this.$route.meta.method === 'view';
            },
            isCreateMethod : function () {
                return this.$route.meta.method === 'create';
            },
            isUpdateMethod : function () {
                return this.$route.meta.method === 'update';
            },
            isDuplicateMethod : function () {
                return this.$route.meta.method === 'duplicate';
            },
            getPageTile : function () {
                if (this.customerObject.company_name) {
                    return this.customerObject.company_name;
                }

                return this.$t('admin.' + this.$route.meta.method + '.title');
            },
           
            getActionButtons : function () {
                let buttons = [];

                if (this.isViewMethod) {
                    if (this.$store.getters.userHasPermission('admin_update')) {
                        buttons.push({
                            action : 'update',
                            router  : { name : 'customers-update-customer-admin', params : { custumor : this.$route.params.customer, account : this.$route.params.account } }
                        });
                    }
                }

                if (this.isCreateMethod) {
                    if (this.$store.getters.userHasPermission('admin_create')) {
                        buttons.push({
                            action : 'save'
                        });
                    }
                }

                if (this.isUpdateMethod) {
                    if (this.$store.getters.userHasPermission('admin_update')) {
                        buttons.push({
                            action : 'save'
                        });
                    }

                    if (parseInt(this.adminObject.id) !== parseInt(this.$store.getters.getUser.id)) {
                        if (this.$store.getters.userHasPermission('admin_activate')) {
                            if (this.adminObject.active) {
                                buttons.push({
                                    action : 'deactivate'
                                });
                            } else {
                                buttons.push({
                                    action : 'activate'
                                });
                            }
                        }
                    }
                }

                buttons.push({
                    action  : 'cancel',
                    router  : { name : 'customers-view-customer-admins', params : { customer : this.$route.params.customer } }
                });

                return buttons;
            }
        },
        watch : {
            '$route' : {
                handler : function () {
                    this.onUpdateCustomer();
                },
                deep    : true
            }
        },
        created : function () {
            this.onUpdateCustomer();
        },
        validations : function () {
            return {
                adminObject : {
                    location_id : {
                        required,
                        isValidNumber : (value) => {
                            return parseInt(value) !== NaN && parseInt(value) >= 1;
                        }
                    },
                    profile : {
                        firstname : {
                            required
                        },
                        lastname : {
                            required
                        },
                        communication : {
                            email : {
                                required,
                                email
                            }
                        }
                    }
                }
            }
        },
        methods : {
            onUpdateCustomer : function() {
                this.customerLoadingError = null;

                if (!this.$route.params.customer) {
                    this.onUpdateAdminObject();
                } else {
                    let promise = this.$api.clearParams()
                        .get('customers/' + this.$route.params.customer + '/get');

                    promise.then((response => {
                        this.customerObject = response.data.data;

                        this.onUpdateAdminObject();
                    }).bind(this)).catch((error => {
                        this.loadingError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.loading = false;
                    }).bind(this));

                    this.loading = true;
                }
            },
            onUpdateAdminObject : function () {
                this.loadingError = null;

                if (!this.isCreateMethod) {
                    let promise = this.$api.clearParams()
                        .get('accounts/' + this.$route.params.account + '/get');

                    promise.then((response => {
                        this.adminObject = response.data.data;
                    }).bind(this)).catch((error => {
                        this.loadingError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.loading = false;
                    }).bind(this));

                    this.loading = true;
                }
            },
            onSubmitAdminObject : function () {
                this.adminFormDisabled     = true;
                this.adminObjectError      = null;
                this.adminObjectSuccess    = null;

                this.$v.adminObject.$touch();

                if (this.$v.adminObject.$invalid) {
                    this.adminFormDisabled     = false;
                    this.adminObjectError      = this.$t('form.error_form');
                } else {
                    if (this.isCreateMethod) {
                        let promise = this.$api.clearParams()
                            .post('accounts/create', this.adminObject);

                        promise.then((response => {
                            this.adminFormDisabled     = false;
                            this.adminObjectSuccess    = this.$t('admin.create.success');

                            this.$router.push({ name : 'customers-update-customer-admin', params : { customer : this.$route.params.customer, account : response.data.data.id } })
                        }).bind(this)).catch((error => {
                            this.adminFormDisabled     = false;
                            this.adminObjectError      = error.response.data.message;
                        }).bind(this));
                    } else if (this.isUpdateMethod) {
                        let promise = this.$api.clearParams()
                            .post('accounts/' + this.$route.params.account + '/update', this.adminObject);

                        promise.then((response => {
                            this.adminFormDisabled     = false;
                            this.adminObjectSuccess    = this.$t('admin.update.success');
                        }).bind(this)).catch((error => {
                            this.adminFormDisabled     = false;
                            this.adminObjectError      = error.response.data.message;
                        }).bind(this));
                    }
                }
            },
            onActivateAdminObject : function () {
                if (!this.adminObject.active) {
                    this.adminObjectActivate = this.$t('admin.active.title');
                } else {
                    this.adminObjectActivate = this.$t('admin.deactive.title');
                }
            },
            onActivateAdminObjectSubmit : function () {
                this.adminFormDisabled     = true;
                this.adminObjectError      = null;
                this.adminObjectSuccess    = null;
                this.adminObjectActivate   = null;

                let promise = this.$api.clearParams()
                    .post('accounts/' + this.$route.params.account + '/activate', {
                        active : !this.adminObject.active
                    });

                promise.then((response => {
                    this.adminFormDisabled = false;

                    if (response.data.data.active) {
                        this.adminObjectSuccess = this.$t('admin.active.success');
                    } else {
                        this.adminObjectSuccess = this.$t('admin.deactive.success');
                    }

                    this.adminObject.active    = response.data.data.active;
                }).bind(this)).catch((error => {
                    this.adminFormDisabled     = false;
                    this.adminObjectError      = error.response.data.message;
                }).bind(this));
            },
            onClickAction : function (action) {
                this.adminObjectError      = null;
                this.adminObjectSuccess    = null;
                this.adminObjectActivate   = null;

                switch (action) {
                    case 'save':
                        this.onSubmitAdminObject();

                        break;
                    case 'activate':
                    case 'deactivate':
                        this.onActivateAdminObject();

                        break;
                }
            },
            onClickActivateDialogAction : function (id, action) {
                this.adminObjectError      = null;
                this.adminObjectSuccess    = null;
                this.adminObjectActivate   = null;

                switch (action) {
                    case 'yes':
                        if (id === 'form-activate') {
                            this.onActivateAdminObjectSubmit();
                        }

                        break;
                }
            }
        }
    }
</script>